/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface IdErrorResultDtoOfString
 */
export interface IdErrorResultDtoOfString {
    /**
     * 
     * @type {string}
     * @memberof IdErrorResultDtoOfString
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdErrorResultDtoOfString
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdErrorResultDtoOfString
     */
    error?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdErrorResultDtoOfString
     */
    $type?: IdErrorResultDtoOfStringTypeEnum;
}


/**
 * @export
 */
export const IdErrorResultDtoOfStringTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoBulkActionResultsIdErrorResultDto1SystemStringSystemPrivateCoreLibPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.BulkActionResults.IdErrorResultDto`1[[System.String, System.Private.CoreLib]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type IdErrorResultDtoOfStringTypeEnum = typeof IdErrorResultDtoOfStringTypeEnum[keyof typeof IdErrorResultDtoOfStringTypeEnum];


/**
 * Check if a given object implements the IdErrorResultDtoOfString interface.
 */
export function instanceOfIdErrorResultDtoOfString(value?: unknown): value is IdErrorResultDtoOfString {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(IdErrorResultDtoOfStringTypeEnum)[0];
}

export function IdErrorResultDtoOfStringFromJSON(json: any): IdErrorResultDtoOfString {
    return IdErrorResultDtoOfStringFromJSONTyped(json, false);
}

export function IdErrorResultDtoOfStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdErrorResultDtoOfString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function IdErrorResultDtoOfStringToJSON(value?: IdErrorResultDtoOfString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'title': value.title,
        'error': value.error,
        '$type': value.$type,
    });
}

